<template>
    <el-card>
        <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/' }">Inicio</el-breadcrumb-item>
            <el-breadcrumb-item>Informes</el-breadcrumb-item>
        </el-breadcrumb>
		<div class="loading" v-if="loading" v-loading="loading"></div>
		<template v-if="!loading">
            <br />
            <app-table-paginate :routeEdit="routeEdit" :routeDelete="true" :routeView="routeView" :tableQuery="tableData" :tableColumns="headers"></app-table-paginate>
            <br />
            <el-button type="primary" size="medium" @click="nuevoRegistro()">Nuevo <i class="el-icon-circle-plus-outline el-icon-right"></i></el-button>

        </template>
    </el-card>
</template>

<script>
	import ApiService from '@/common/api.service'
	import tablaConPaginador from '@/components/Dashboard/commons/tablaConPaginador'
	import { mapGetters } from "vuex"

    export default {
        name: 'Informes',
        components: {
			'app-table-paginate': tablaConPaginador
        },
        computed: {
			...mapGetters(['isAdmin'])
		},
        created () {

            if(!this.isAdmin){
                this.$router.replace('/dashboard/misinformes')
            }
            this.routeView = 'informe/'
			this.routeEdit ='/dashboard/form/informe/'
			this.init()
			this.$root.$on('delete', (id) => {
                this.eliminarRegistro(id)
            })
        },
        data () {
            return  {
				loading: true,
				headers: [
                {
                    'prop': 'icono',
                    'label': 'Icono'
                },
                {
                    'prop': 'nombre',
                    'label': 'Nombre'
                },
                {
                    'prop': 'url',
                    'label': 'URl'
                }],
				field: {},
				tableQuery: {},
				nametable: this.$route.params.table,
				relationship: [],
				routeEdit: null,
				deleterow: false
            }
        },
        watch: {
			$route(to) {
				this.loading = true
				this.tableQuery = {}
				this.headers = []
				this.routeEdit = '/dashboard/form/informe/'
				this.init()
			}
		},
        methods: {
			init() {
				this.getTableData()
            },
            nuevoRegistro() {
                this.$router.push('/dashboard/form/informe/')
            },
            async getTableData() {
                ApiService.post("public/v1", {
					token: localStorage.getItem("analiticatoken"),
                    single: false,
                    method: 'select',
                    fields: ['informes.id', 'informes.nombre', 'informes.descripcion', 'informes.url, informes.icono'],
                    table: 'informes',
                    order: [' informes.id DESC'],
                }).then(response => {
                    if(response.data == 'Algo ha fallado'){
                        this.tableData = []
                    }else{
	    				this.tableData = response.data
                    }
                    setTimeout(() => {
                        this.loading = false
                    }, 100);
                })
            },
            async eliminarRegistro (id){
                this.loading = true
                ApiService.post("public/v1", {
                    token: localStorage.getItem("analiticatoken"),
                    method: 'DELETE',
                    id: id ,
                    table: 'informes',
                }).then(response => {
                    if(response.data == 1){
                        this.$root.$emit('msgSuccess', 'Registro ELIMINADO')
                        setTimeout(() => {
                            this.init()
                        }, 1000);
                    }else{
                        this.$root.$emit('msgError', 'Algo ha fallado')
                    }
                })
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Dashboard/Informes.vue